//-----------------------------------------------------------------------------
//  Copyright (c) 2026 by Dell Inc.
//
// All rights reserved.  This software may not be copied, disclosed,
// transferred, or used except in accordance with a license granted
// by Dell Inc.  This software embodies proprietary information
// and trade secrets of Dell Inc.
//
//-----------------------------------------------------------------------------

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { loadPolyfillsAsync } from './polyfills';
import * as serviceWorker from './registerServiceWorker'
import ReactDOM from 'react-dom';
import 'sanitize.css';
import App from './App';
import { ai } from './telemetry/Telemetry';

loadPolyfillsAsync().then(async () => {
  if (process.env.NODE_ENV === 'production') {
    ai.initialize();
    ReactDOM.render(<App />, document.getElementById('root'));
  }

  if (process.env.NODE_ENV === 'development') {
    // const LocalDashboard = await import('./local-dashboard/LoginScreen').then((c) => c.default);
    // const loginResponse = await fetch(`/api/GlobalInfo`, { credentials: 'same-origin' });
    // if (loginResponse.redirected) {
    //   ReactDOM.render(<LocalDashboard />, document.getElementById('root'));
    // } else {
      ReactDOM.render(<App />, document.getElementById('root'));
    // }
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

